import React from 'react'
import { isMobile } from 'react-device-detect'
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons'
import {
  $DCprimaryColor,
  DcButton,
  DcDropDown,
  DcInput,
  PixelFactoryContext,
  PixelIcon,
} from 'pixel-base'
import styled from 'styled-components'

import { addDiscountLine, addinvoiceDiscountLine } from 'utils/api-routes.util'
import { IPixelFactory, OrderDetail } from '../../../../../../decl.d'

interface IProps {
  handleClose: () => void
  detailID: number
  newOrder: boolean
  newOrderData: OrderDetail
  setNewOrderData: (newOrderData: OrderDetail) => void
  isItInvoice: boolean
  newInvoice: boolean
}
const AddDiscountLines = (props: IProps) => {
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const {
    handleClose,
    detailID,
    newOrder,
    setNewOrderData,
    newOrderData,
    isItInvoice,
    newInvoice,
  } = props
  const [error, setError] = React.useState({
    error: '',
    field: '',
  })
  const [data, setData] = React.useState({
    amount: '',
    type: 'fixed_amount',
  })
  const handleSubmit = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault()
    }
    if (newOrder) {
      setNewOrderData({
        ...newOrderData,
        discounts: [
          ...(newOrderData?.discounts || {}),
          {
            amount: data.amount,
            discount_code: data.type,
            line_id: null,
          },
        ],
      })
      setData({
        amount: '',
        type: '',
      })
      handleClose()
    } else {
      handleAdddiscount()
    }
  }
  const handleAdddiscount = () => {
    if (isItInvoice) {
      showPageLoader()
      addinvoiceDiscountLine(detailID, data).subscribe((res: any) => {
        hidePageLoader()
        if (res.response.data) {
          showSuccess('Successfully Added')
          handleClose(res.response.data)
        } else {
          if (res.response.error && res.response.field) {
            setError({
              error: res.response.error,
              field: res.response.field,
            })
          } else {
            showFailure(res.response.error)
          }
        }
      })
    } else {
      showPageLoader()
      addDiscountLine(detailID, data).subscribe((res: any) => {
        hidePageLoader()
        if (res.response.data) {
          showSuccess('Successfully Added')
          handleClose(res.response.data)
        } else {
          if (res.response.error && res.response.field) {
            setError({
              error: res.response.error,
              field: res.response.field,
            })
          } else {
            showFailure(res.response.error)
          }
        }
      })
    }
  }
  const DiscountLines = [
    {
      name: 'Fixed Amount',
      value: 'fixed_amount',
    },
    {
      name: 'Percentage',
      value: 'percentage',
      disabled: isItInvoice || newInvoice ? false : true,
    },
  ]
  const handleNegativePrice = (e) => {
    if (e.key === '-') {
      e.preventDefault()
      showFailure('Discount can not be Negative')
    }
  }
  return (
    <>
      <FormContainer onSubmit={handleSubmit}>
        <FormGroup>
          <DcDropDown
            dropdownSize={isMobile ? 'sm' : 'md'}
            error={
              error.field === 'type' && error.error !== '' ? error.error : null
            }
            options={DiscountLines.map((data) => {
              return {
                label: data.name,
                value: data.value,
                disabled: data.disabled,
              }
            })}
            placeholder={'Select Discount Method'}
            name={' Select Discount Method'}
            value={data.type}
            onChange={(e) => {
              setData({ ...data, type: e.target.value })
            }}
          />
          <DcInput
            inputSize={isMobile ? 'small' : 'medium'}
            error={
              error.field === 'amount' && error.error !== ''
                ? error.error
                : null
            }
            required
            type={'number'}
            name={'amount'}
            placeholder={data.type === 'fixed_amount' ? 'Amount' : 'Percentage'}
            value={data.amount}
            min={0}
            max={data.type === 'percentage' ? 100 : null}
            onKeyDown={handleNegativePrice}
            onChange={(e) => {
              if (data.type === 'percentage') {
                if (e.target.value > 100) {
                  showFailure('Percentage can not be greater than 100')
                  return
                }
              }
              setData({
                ...data,
                amount: e.target.value,
              })
            }}
          />
        </FormGroup>

        <Actions>
          <DcButton
            size={'sm'}
            variant="link"
            onClick={() => {
              handleClose()
            }}
          >
            <PixelIcon
              showTooltip
              tooltip="Cancel"
              icon={faXmark}
              color={$DCprimaryColor}
            />
          </DcButton>
          <DcButton
            type="submit"
            disabled={data.amount === '' || data.type === ''}
            // size="sm"
            variant="link"
            onClick={handleSubmit}
          >
            <PixelIcon
              showTooltip
              tooltip="Update"
              icon={faCheck}
              color={$DCprimaryColor}
            />
          </DcButton>
        </Actions>
      </FormContainer>
    </>
  )
}

const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: ${isMobile ? '0px' : '10px'};
`

const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: ${isMobile ? 'column' : 'row'};
  flex-wrap: nowrap;
  justify-content: ${(props) => (props.flexEnd ? 'flex-end' : 'center')};
  align-items: flex-start;
  align-content: flex-start;
  width: 75%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`
const Actions = styled.div`
  display: flex;
  flex-direction: ${isMobile ? 'column' : 'row'};
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 5px;
  width: 25%;
`
export default AddDiscountLines
